import './App.css';
import { Signup } from './components/Signup';

function App() {
  return (
    <div className='container mt-3' style={{backgroundColor: 'transparent'}}>
      <div className='row'>
         <div className='col-md-6'>
            <Signup/>
         </div>
      </div>
    </div> 
  );
}

export default App;
